import AboutComponent from "../components/About";
//import TestimonialCard from "../components/TestimonialCard";
//import { testimonials } from "../data/testimonials";

export default function About() {
  return (
    <div className="pt-16 md:pt-20">
      {/* Page Header */}
      <section className="bg-gradient-to-r from-[#033644] to-[#1E3A8A] py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-white mb-6">
            Sobre Nosotros
          </h1>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            Conoce nuestra historia, misión y el equipo detrás de Technova
          </p>
        </div>
      </section>

      {/* About Content */}
      <AboutComponent />

      {/* Mission & Vision */}
      <section className="py-16 md:py-24 bg-[#F9FAFB]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <div className="flex items-center mb-4">
                <i className="fas fa-bullseye text-4xl text-[#FFA500] mr-4"></i>
                <h3 className="text-2xl font-heading font-semibold text-[#033644]">
                  Nuestra Misión
                </h3>
              </div>
              <p className="text-gray-700 leading-relaxed">
                Proporcionar soluciones tecnológicas innovadoras y de alta
                calidad que impulsen el crecimiento y la competitividad de las
                empresas en Guinea Ecuatorial, contribuyendo al desarrollo
                tecnológico del país.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-lg">
              <div className="flex items-center mb-4">
                <i className="fas fa-eye text-4xl text-[#FFA500] mr-4"></i>
                <h3 className="text-2xl font-heading font-semibold text-[#033644]">
                  Nuestra Visión
                </h3>
              </div>
              <p className="text-gray-700 leading-relaxed">
                Ser la empresa líder en soluciones tecnológicas en Guinea
                Ecuatorial, reconocida por nuestra excelencia, innovación y
                compromiso con el éxito de nuestros clientes.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials 
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-heading font-semibold text-[#033644] mb-4">
              Testimonios de Clientes
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {testimonials.map((testimonial) => (
              <TestimonialCard key={testimonial.id} testimonial={testimonial} />
            ))}
          </div>
        </div>
      </section>*/}
    </div>
  );
}